import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';

const AppLayout = () => (
  <>
    <Sidebar />
    <div className="root-container">
      <Outlet />
      <div className="footer">
        <a href="https://www.aren.com" className="custom-link" target="_blank" rel="noopener noreferrer">
          © 2026 Kabilah, Inc.
        </a>
      </div>
    </div>
  </>
);

export default AppLayout;
